import maskMoney from "../../../../utils/maskMoney";
import redirectToAppStore from "../../../../utils/redirectToAppStore";
import { useMainContext } from "../../../../context";

import { IoTime, IoCash, IoCar } from "react-icons/io5";
import { useMemo } from "react";

const RestaurantHeader = () => {
  const { restaurantDeliveryPrice, restaurant } = useMainContext();

  const deliveryPriceValue = useMemo(() => {
    if (!restaurant || !restaurantDeliveryPrice) return null;

    if (restaurantDeliveryPrice === "0.00") return "Grátis";

    return maskMoney(restaurantDeliveryPrice);
  }, [restaurant, restaurantDeliveryPrice]);

  const deliveryTime = useMemo(() => {
    if (!restaurant) return null;

    let minDeliveryPrice = 0;
    let maxDeliveryPrice = 0;

    restaurant.delivery_prices.forEach((dp) => {
      const price = parseFloat(dp.delivery_price);
      if (price < minDeliveryPrice || minDeliveryPrice === 0) {
        minDeliveryPrice = price;
      }
      if (price > maxDeliveryPrice) {
        maxDeliveryPrice = price;
      }
    });

    const averageTime = restaurant.settings?.average_delivery_time;
    const restaurantHasHighDemand = restaurant.settings?.high_demand_status;

    if (!averageTime) return null;

    let time = averageTime;

    if (restaurantHasHighDemand) {
      time += restaurant.settings.high_demand_time;
    }

    if (
      minDeliveryPrice &&
      maxDeliveryPrice &&
      minDeliveryPrice !== maxDeliveryPrice
    ) {
      return `${time + minDeliveryPrice}-${time + maxDeliveryPrice} min`;
    }

    return `${time + maxDeliveryPrice} min`;
  }, [restaurant]);

  const minValueForOrder = useMemo(
    () =>
      restaurant?.settings?.minimum_order_amount
        ? maskMoney(restaurant?.settings?.minimum_order_amount)
        : null,
    [restaurant],
  );

  const badges = useMemo(
    () => [
      {
        name: "Entrega",
        value: deliveryPriceValue ?? "Retirar",
        icon: IoCar,
      },
      {
        name: "Tempo",
        value: deliveryTime ?? "N/A",
        icon: IoTime,
      },
      {
        name: "Mínimo",
        value: minValueForOrder ?? "N/A",
        icon: IoCash,
      },
    ],
    [minValueForOrder, deliveryTime, deliveryPriceValue],
  );

  return (
    <div className="p-8 md:p-12 bg-primary-500 flex flex-col items-startrelative text-white">
      {!restaurant?.id ? (
        <>
          <div className="w-28 h-28 border-2 border-white mb-8 rounded-lg bg-gray-300 animate-pulse" />
          <div className="w-full h-8 mb-2 rounded-lg bg-gray-300 animate-pulse" />
          <div className="w-3/4 h-8 mb-6 rounded-lg bg-gray-300 animate-pulse" />
          <div className="w-full h-24 mb-4 rounded-[16px] bg-gray-300 animate-pulse" />
          <div className="w-full h-16 mb-4 rounded-[16px] bg-gray-300 animate-pulse" />
        </>
      ) : (
        <>
          <div className="w-20 h-20 md:w-28 md:h-28 border-2 border-white mb-8 rounded-lg animate-slideUp">
            <img
              src={restaurant.logo}
              alt={`${restaurant.fantasy_name} logo`}
            />
          </div>

          <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tighter mb-6 leading-none line-clamp-3 animate-slideUp">
            {restaurant.fantasy_name}
          </h2>

          {!restaurant.isWorking && (
            <span className="bg-secondary-500 text-black px-4 py-2 inline-block self-start font-bold text-xs md:text-sm mb-6 rounded-full">
              Fechado
            </span>
          )}

          <div className="bg-white rounded-[16px] p-4 2xl:p-6 mb-4 text-black grid grid-cols-3">
            {badges.map((badge, index) => (
              <div
                className="flex flex-col items-center justify-center px-2 text-center opacity-0 animate-slideUp"
                style={{ animationDelay: `${index * 120}ms` }}
                key={index}
              >
                <badge.icon size={24} className="text-primary-500 mb-2" />
                <span className="text-[10px] font-bold uppercase text-gray-400 mb-1">
                  {badge.name}
                </span>
                <span className="text-xs 2xl:text-sm font-black line-clamp-1">
                  {badge.value}
                </span>
              </div>
            ))}
          </div>

          <button
            onClick={() => redirectToAppStore()}
            className="bg-secondary-500 text-primary-500 p-3 rounded-[16px] text-sm font-bold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-primary-500/20 active:scale-95 animate-slideUp"
          >
            Hey buddy, clique aqui para baixar o app e trocar cashback por
            descontos no seu pedido
          </button>
        </>
      )}
    </div>
  );
};

export default RestaurantHeader;
